export default __webpack_public_path__ + "static/media/colorWhatIfNew.c532d581.svg";